'use client';
import React from 'react';

import Popover from 'antd/es/popover';
import Link from 'next/link';

import { SuitCase } from '@assets/icons';
import useIsMounted from '@hooks/useIsMounted';

import OnlineTransactionLinks from './OnlineTransactionLinks';
import { ONLINE_TRANSACTION_LINKS } from './const';
import { HeaderReservationsWrapper } from './styled';

const DesktopHeaderReservations = () => {
  const [element] = useIsMounted();
  if (!element) return null;
  return (
    <Popover
      content={<OnlineTransactionLinks />}
      styles={{
        body: {
          borderRadius: '2px',
          boxShadow: '0px 0px 8px 0px rgba(0, 17, 68, 0.08)',
          padding: '4px',
          overflow: 'hidden',
        },
      }}
    >
      <Link prefetch={false} href={ONLINE_TRANSACTION_LINKS?.[0]?.href}>
        <HeaderReservationsWrapper>
          <SuitCase />
          <span>{ONLINE_TRANSACTION_LINKS?.[0]?.title}</span>
        </HeaderReservationsWrapper>
      </Link>
    </Popover>
  );
};

export default DesktopHeaderReservations;
